// Ported verbatim from deexoptions-mobile-app/hooks/queries/transactionKeys.ts

import type { ActivityFilter } from "../../utils/activity/filters";

// Every filter dimension is part of the key so each combination is its own
// cache entry — switching filters can never show another filter's rows.
export const transactionKeys = {
  all: ["transactions"] as const,
  list: (filter: ActivityFilter, limit: number) =>
    [
      "transactions",
      "list",
      filter.type,
      filter.subtype ?? "-",
      filter.status ?? "-",
      filter.startDate ?? "-",
      filter.endDate ?? "-",
      filter.coin?.toLowerCase() ?? "-",
      limit,
    ] as const,
  // Mixed `/recent` feed — not a filtered list, so it gets its own namespace and
  // can never collide with a `list` entry at the same coin/limit.
  recent: (coin: string | undefined, limit: number) =>
    ["transactions", "recent", coin?.toLowerCase() ?? "all", limit] as const,
  summary: (filter: ActivityFilter) =>
    [
      "transactions",
      "summary",
      filter.type,
      filter.subtype ?? "-",
      filter.startDate ?? "-",
      filter.endDate ?? "-",
      filter.coin?.toLowerCase() ?? "-",
    ] as const,
};
